import { localNum } from "@faire/web--source/common/localization";
import { Column } from "@faire/web--source/slate/Layout";
import React from "react";

import { InsiderTileBadgeRenderer } from "@faire/retailer/components/InsiderBadge/InsiderTileBadgeRenderer";
import { MaybeBrandReviewTile } from "@faire/retailer/components/MaybeBrandReviewTile/MaybeBrandReviewTile";
import { BrandMinimum } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/BrandMinimum";
import { BrandNameText } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/BrandNameText";
import { BrandPromoText } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/BrandPromoText";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { MarketplaceProductBrandLinkBase } from "@faire/retailer/features/MarketplaceItems/ProductDetailsTile/__internal__/SearchMarketplaceProductBrandLinkBase";
import { DiscoveryProductTileBrandInfoProps } from "@faire/retailer/features/MarketplaceItems/ProductDetailsTile/DiscoveryProductTileBrandInfo";

const DiscoveryProductTileFullClickBrandInfoBase: React.FC<
  DiscoveryProductTileBrandInfoProps
> = ({
  brand,
  isLoggedInRetailer,
  isLoaded,
  avgBrandReviewRating,
  brandReviewCount,
  brandPromoText,
  insiderBadgeProps,
  isHighlightedProductForPromotionalEvent,
}) => {
  return (
    <Column gap={{ mobileAndAbove: 2, tabletAndAbove: 4 }}>
      <BrandNameText
        withLink={false}
        brandToken={brand.token}
        brandIcon={brand.icon}
        brandName={brand.name}
        isLoaded={isLoaded}
      />
      <BrandMinimum
        minimumOrderAmount={brand.minimumOrderAmount}
        avgBrandReviewRating={avgBrandReviewRating}
        isLoggedInRetailer={isLoggedInRetailer}
      />
      <InsiderTileBadgeRenderer {...insiderBadgeProps} />
      {brandPromoText ? (
        <BrandPromoText
          promoText={brandPromoText}
          isHighlightedPromo={isHighlightedProductForPromotionalEvent}
        />
      ) : null}
      {!isLoggedInRetailer ? (
        <MaybeBrandReviewTile
          rating={ratingString(avgBrandReviewRating, brandReviewCount)}
        />
      ) : null}
    </Column>
  );
};

const ratingString = (
  avgBrandReviewRating: string | undefined,
  brandReviewCount: number | undefined
) => {
  if (avgBrandReviewRating && brandReviewCount) {
    return `${avgBrandReviewRating} (${localNum(brandReviewCount)})`;
  }
  return undefined;
};

export const DiscoveryProductTileFullClickBrandInfo: React.FC<
  DiscoveryProductTileBrandInfoProps
> = ({ shouldUseClickContext, ...props }) => {
  return shouldUseClickContext ? (
    // RSC branch, the link is already wrapped in the SearchProductTileBrandLink
    //  all click handlers are wrapped in as well
    <DiscoveryProductTileFullClickBrandInfoBase {...props} />
  ) : (
    // Non-rsc branch, use MarketplaceProductBrandLinkBase instead
    <MarketplaceProductBrandLinkBase
      brandToken={props.brand.token}
      onBrandLinkClick={props.onBrandLinkClick}
      generateBrandUrl={props.generateBrandUrl}
    >
      <DiscoveryProductTileFullClickBrandInfoBase {...props} />
    </MarketplaceProductBrandLinkBase>
  );
};
